import resetPasswordComponentTemplate from "./resetPasswordComponentTemplate.js";
import {eyeIcon, eyeSlashIcon} from "../LoginComponent/LoginComponentIcons.js";
import forgotPasswordMessages from "../../constants/forgotPasswordMessages.js";


export default class CEGuidelineCognitoResetPassword extends HTMLElement {
  constructor() {
    super();
    const shadow = this.attachShadow({ mode: "open" });
    const template = document.createElement("template");
    template.innerHTML = resetPasswordComponentTemplate;
    shadow.appendChild(template.content.cloneNode(true));
    this.shadowRoot.querySelector("#new-password-form-submit").addEventListener("click", this.onResetPasswordSent.bind(this));
    this.shadowRoot.querySelector("#new-password-eye-icon-button").addEventListener("click", this.showHidePassword.bind(this));
    this.shadowRoot.querySelector("#new-reset-password").placeholder = forgotPasswordMessages.PASSWORD_PLACEHOLDER;
    this.shadowRoot.querySelector("#backtologin").innerText = forgotPasswordMessages.BACK_TO_SIGN_IN_TEXT;
    this.shadowRoot.querySelector("#backtologin").addEventListener("click", this.onBackToSignIn.bind(this));
    this.addIcons();
  }

  addIcons() {
    const eyeImages = this.shadowRoot.querySelector("#new-password-eye-icon");   
    eyeImages.setAttribute("src", eyeIcon);
  }

  
  showPasswordResetErrorMessage() {
    const errorMessage = this.shadowRoot.querySelector(
      "#new-password-error-message"
    );
    errorMessage.style.display = "block";
    const message = forgotPasswordMessages.PASSWORD_RESET_ERROR_MESSAGE;
    errorMessage.innerText = message;
  }


  onBackToSignIn() {   
    setTimeout(function(){
      window.location.reload();
    });
  }

  validatePassword(event) {
    const value = event.target.value;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.[\]{}()?""!@#%&/\\,><':;|_~`=+-])[A-Za-z\d\^$*.[\]{}()?""!@#%&/\\,><':;|_~`=+-]{8,}$/;
    
    if (!passwordRegex.test(value)) {
      const errorMessage = this.shadowRoot.querySelector("#forgot-password-error-message");
      errorMessage.style.display = "block";
      const message = forgotPasswordMessages.PASSWORD_VALIDATION_ERROR_MESSAGE;
      errorMessage.innerText = message;
    } else {
      const errorMessage = this.shadowRoot.querySelector("#forgot-password-error-message");
      errorMessage.style.display = "none";
    }
  }


  getFormValues() {
    const newPassword = this.shadowRoot.querySelector("#new-reset-password").value;
    return {
        newPassword
    };
  }

  validateForm() {
      const { newPassword } = this.getFormValues();
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.[\]{}()?""!@#%&/\\,><':;|_~`=+-])[A-Za-z\d\^$*.[\]{}()?""!@#%&/\\,><':;|_~`=+-]{8,}$/;
      const displayBlock = "block";
      const displayNone = "none";
      const bullet = "&#8226; ";
      let valid = true;

      const errorMessage = this.shadowRoot.querySelector("#new-password-error-message");
      errorMessage.innerHTML = "";
      errorMessage.style.display = displayNone;      

      if (!passwordRegex.test(newPassword)) {
          errorMessage.style.display = displayBlock;
          errorMessage.innerHTML += bullet + forgotPasswordMessages.PASSWORD_VALIDATION_ERROR_MESSAGE;
          valid = false;
      }

      return valid;
  }

  async onResetPasswordSent(e) {
      e.preventDefault();

      if (!this.validateForm()) {
          return;
      }

      const { newPassword } = this.getFormValues();
      const displayBlock = "block";

      // Disable the back-to-login button up front so it can't interrupt the in-flight
      // reset + automatic sign-in transition (clicking it reloads the page).
      this.shadowRoot.querySelector("#backtologin").disabled = true;

      this._cognito.changePassword(this.user, newPassword).then((data) => {
              this.shadowRoot.querySelector("#new-password-sucess-message").style.display = displayBlock;
              this.shadowRoot.querySelector("#new-password-sucess-message").innerText = forgotPasswordMessages.PASSWORD_RESET_SUCCESS_MESSAGE;
              this.shadowRoot.querySelector("#new-password-form-submit").disabled = true;
              this.shadowRoot.querySelector("#new-password-eye-icon-button").disabled = true;
              // Show a small loader for the brief wait before we transition into the app.
              this.shadowRoot.querySelector("#reset-inline-loader").style.display = "block";
              // confirmSignIn has already established a valid, freshly-verified session for this
              // user with the new password. Instead of signing out and forcing a re-login
              // (the MT-23529 stale-session trap), carry that session straight into the app via
              // the continuation wired by the login component. The brief delay lets the success
              // message register before we move to the org-selection screen.
              setTimeout(() => {
                if (typeof this.onResetComplete === 'function') {
                    this.onResetComplete();
                } else {
                    // Fallback (component used standalone, no continuation wired): preserve the
                    // old behaviour — clear the session so the next signIn() starts fresh.
                    this._cognito.signOutCurrentSession().finally(() => location.reload(true));
                }
              }, 2000);
          }).catch((err) => {
              // Re-enable so the user isn't stranded on a dead form if the reset failed.
              this.shadowRoot.querySelector("#backtologin").disabled = false;
              this.showPasswordResetErrorMessage();
          });
  }

  showHidePassword() {
    const passwordInput = this.shadowRoot.querySelector("#new-reset-password");
    const eyeIconElement = this.shadowRoot.querySelector("#new-password-eye-icon");
    passwordInput.type = passwordInput.type === "password" ? "text" : "password";
    eyeIconElement.setAttribute('src', passwordInput.type === "password" ? eyeIcon : eyeSlashIcon);
  }

  set user(value) {
    this._user = value;
  }

  get user() {
    return this._user;
  }

  get cognito() {
    return this._cognito;
  }

  set cognito(value) {
    this._cognito = value;
  }
}
